import { lazy } from "react";

const Index = lazy(() => import("./Broadcast"));
const Detail = lazy(() => import("./BroadcastDetail"));

export { Index, Detail };
